// START Open Requre.JS wrapper
define([
	'require',
	'jquery'
], function(require, $) {
// END Open Require.JS wrapper

/****
 * Add carousel support to the top nav promo bar
 ***/
	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "promoBar";
	var promoBar;

	(function(){
		promoBar = {
			defaults: {
				el: ".topnav-promobar",
				dataAttr: "promobar-options",
				promobarCarousel: "topnav-promobar-carousel",
				globalPromoLink: "topnav-promobar-global-link"
			},

			carouselDefaults: {
				carousel: ".carousel",
				timeout: 4000,
				slides: "> .slide",
				pauseOnHover: true,
				fx: "scrollHorz",
				prev: '.cycle-prev',
				next: '.cycle-next',
				'pagerTemplate': '<span></span>',
				swipe: true,
				maxZ: 49
			},

			init: function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this;
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.carouselDefaults, self.metadata );

				//Check if carousel is enabled
				if(self.$element.hasClass(self.config.promobarCarousel)) {
					return self.initCarousel();
				}
				else {
					self.deferred.resolve();
				}

				return self;
			},

			initCarousel: function() {
				var self = this;

				// set the next/prev buttons elements
				self.config.prev = self.$element.find(self.config.prev);
				self.config.next = self.$element.find(self.config.next);

				require([
					'cycle'
				], function(cycle) {
					var $carousel = self.$element.find(self.config.carousel),
						$slides = $carousel.find('.slide'),
						$liveRegion = self.$element.find('.liveregion'),
						liveText = $liveRegion.data('live-text'),
						$sentinel;

					// pause when focus enters carousel (cycle2 only supports pause on hover)
					self.$element.on('focusin', function() {
						$carousel.cycle('pause');
					});

					// resume when focus leaves carousel
					self.$element.on('focusout', function() {
						$carousel.cycle('resume');
					});

					self.$element.on('cycle-update-view', function(event, optionHash, slideOptionsHash, currentSlideEl) {
						//ensure cycle2's "ghost" slide is hidden from screen readers
						if(!$sentinel) {
							$sentinel = $carousel.find('.cycle-sentinel').attr('aria-hidden', true);
						}

						// ensure off-screen slides are hidden from screen readers 
						$slides.attr('aria-hidden', true);
						currentSlideEl.setAttribute('aria-hidden', false);
					});

					// when next/prev buttons are clicked, update the liveregion for screenreaders
					self.$element.on('cycle-next cycle-prev', function(event, optionHash) {
						$liveRegion.text(liveText.replace("{0}", (optionHash.currSlide + 1)));
					});

					// init carousel
					$carousel.cycle(self.config);

					self.deferred.resolve();
				});

				return self.deferred;
			}
		};

		return promoBar.init();

	})();

	return promoBar;
});